import DOMPurify from 'dompurify';

export function safeRichTextHtml(input) {
    const raw = (input ?? '').toString();
    if (!raw) return '';

    // If content looks like HTML, sanitize and render.
    const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
    if (looksLikeHtml) {
        return DOMPurify.sanitize(raw, {
            USE_PROFILES: { html: true },
            ALLOWED_TAGS: [
                'p', 'br',
                'ul', 'ol', 'li',
                'strong', 'b', 'em', 'i', 'u',
                'h1', 'h2', 'h3', 'h4',
                'a',
            ],
            ALLOWED_ATTR: ['href', 'target', 'rel'],
        });
    }

    // Plain text: preserve newlines as <br/>
    const escaped = raw
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return escaped.replace(/\r?\n/g, '<br/>');
}

